/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscordMessageAuthor
 */
export interface DiscordMessageAuthor {
    /**
     * 
     * @type {string}
     * @memberof DiscordMessageAuthor
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscordMessageAuthor
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscordMessageAuthor
     */
    discriminator?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscordMessageAuthor
     */
    avatar?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscordMessageAuthor
     */
    bot?: boolean;
}

/**
 * Check if a given object implements the DiscordMessageAuthor interface.
 */
export function instanceOfDiscordMessageAuthor(value: object): value is DiscordMessageAuthor {
    return true;
}

export function DiscordMessageAuthorFromJSON(json: any): DiscordMessageAuthor {
    return DiscordMessageAuthorFromJSONTyped(json, false);
}

export function DiscordMessageAuthorFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordMessageAuthor {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'username': json['username'] == null ? undefined : json['username'],
        'discriminator': json['discriminator'] == null ? undefined : json['discriminator'],
        'avatar': json['avatar'] == null ? undefined : json['avatar'],
        'bot': json['bot'] == null ? undefined : json['bot'],
    };
}

export function DiscordMessageAuthorToJSON(json: any): DiscordMessageAuthor {
    return DiscordMessageAuthorToJSONTyped(json, false);
}

export function DiscordMessageAuthorToJSONTyped(value?: DiscordMessageAuthor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'username': value['username'],
        'discriminator': value['discriminator'],
        'avatar': value['avatar'],
        'bot': value['bot'],
    };
}

